import React, { useEffect, useState } from 'react';

export function AnimatedCounter({ value = 0, duration = 800, delay = 0 }) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const num = typeof value === 'number' && !isNaN(value) ? Math.floor(value) : 0;
    if (num === 0) {
      setDisplayValue(0);
      return;
    }

    const startTime = Date.now() + delay;
    const endValue = num;

    const animate = () => {
      const now = Date.now();
      if (now < startTime) {
        requestAnimationFrame(animate);
        return;
      }

      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(easeOut * endValue);

      setDisplayValue(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setDisplayValue(endValue);
      }
    };

    const frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [value, duration, delay]);

  return <span>{displayValue.toLocaleString('pl-PL')}</span>;
}
